import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  TextField,
  RadioGroup,
  Radio,
} from '@mui/material';

const StaffPresentInfoSection = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleFieldChange,
  allGoalData,
}) => {
  const preventNumberScroll = (event) => {
    event.preventDefault();
    event.target.blur();
  };

  const shouldShowStaffInfo =
    allGoalData?.DataEntrySelection?.DataEntrySelection?.includes(
      'Add Staff Present Information'
    ) || dataPoint?.selectedOptions?.includes('Add Staff Present Information');

  if (!shouldShowStaffInfo) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint?.selectedOptions?.includes(
              'Add Staff Present Information'
            )}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Staff Present Information'
          />
        }
        label='Add Staff Present Information'
      />

      {dataPoint?.selectedOptions?.includes(
        'Add Staff Present Information'
      ) && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ gap: 2, marginTop: '10px', marginBottom: '10px' }}>
            <Typography variant='body1'>
              Were there additional staff members present?
            </Typography>
            <RadioGroup
              row
              value={
                dataPoint.additionalStaff === ''
                  ? ''
                  : dataPoint.additionalStaff
                  ? 'yes'
                  : 'no'
              }
              onChange={(e) =>
                handleFieldChange(
                  index,
                  'additionalStaff',
                  e.target.value === 'yes'
                    ? true
                    : e.target.value === 'no'
                    ? false
                    : ''
                )
              }
            >
              {/* Intentionally omit a default selection; show Yes/No only */}
              <FormControlLabel value='yes' control={<Radio />} label='Yes' />
              <FormControlLabel value='no' control={<Radio />} label='No' />
            </RadioGroup>
            {dataPoint.additionalStaff === true && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mt: 1,
                  ml: 4,
                }}
              >
                <Typography variant='body1'>How many? </Typography>
                <TextField
                  type='number'
                  value={
                    dataPoint?.numberOfStaffs === 0
                      ? ''
                      : dataPoint?.numberOfStaffs ?? ''
                  }
                  onChange={(e) =>
                    handleFieldChange(
                      index,
                      'numberOfStaffs',
                      e.target.value === '' ? '' : Number(e.target.value)
                    )
                  }
                  sx={{
                    width: 100,
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      '&:hover': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#6b7280',
                        },
                      },
                      '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#6b7280',
                        },
                      },
                    },
                  }}
                  inputProps={{ min: 0, onWheel: preventNumberScroll }}
                />
              </Box>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default StaffPresentInfoSection;
